<template>
  <v-row justify="center">
    <v-dialog :value="value" @input="$emit('input')" persistent max-width="600px">
      <v-card v-if="influencer || multiple">
        <v-toolbar color="elevation-2">
          <h2 class="headline" v-if="!multiple">@{{ influencer.userHandle }} </h2>
          <v-spacer></v-spacer>
          <h2 class="headline" v-if="multiple">Update Deliverables</h2>
          <h2 class="headline" v-else>Deliverables</h2>
          <v-spacer></v-spacer>
          <h3 v-if="!multiple">{{ influencer.payoutAmount }}$</h3>
          <v-btn icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-list v-if="!multiple">
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <!-- <v-list-item-title class="subtitle-1">
                  TikTok Posts
                </v-list-item-title> -->
              </v-list-item-content>
              <v-list-item-action>
                <p class="body-1 mb-0">
                  {{ '$' + pairedInfluencer.multipliedPrice1 + ' - $' + pairedInfluencer.multipliedPrice2}}
                  <v-icon right>mdi-account-cog</v-icon>
                </p>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  TikTok Posts
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field type="number" solo v-model.number="no_of_tiktok_posts" min="0" dense hide-details></v-text-field>
                <span class="hint--text">in number of TikTok Posts</span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  XHS Posts
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field type="number" solo v-model.number="no_of_xhs_posts" min="0" dense hide-details></v-text-field>
                <span class="hint--text">in number of Xiaohongshu Posts</span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  FB Posts
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field type="number" solo v-model.number="no_of_fb_posts" min="0" dense hide-details></v-text-field>
                <span class="hint--text">in number of Facebook Posts</span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  IG Posts
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                type="number"
                solo
                dense
                v-model.number="no_of_posts"
                min="0"
                hide-details></v-text-field>
              <span class="hint--text">in number of IG Posts</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  IG Carousels
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field type="number" solo dense v-model.number="no_of_carousels" min="0" hide-details></v-text-field>
                <span class="hint--text">in number of IG Carousels</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="no_of_video" class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  IG Videos
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field type="number" solo dense v-model.number="no_of_video" min="0" hide-details></v-text-field>
                <span class="hint--text">in number of Videos</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  IG Stories
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field type="number" solo dense v-model.number="no_of_stories" min="0" hide-details></v-text-field>
                <span class="hint--text">in number of IG Stories</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  IG Reels
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field type="number" solo dense v-model.number="no_of_reels" min="0" hide-details></v-text-field>
                <span class="hint--text">in number of IG Reels</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  LinkedIn Posts
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field type="number" solo dense v-model.number="no_of_li_posts" min="0" hide-details></v-text-field>
                <span class="hint--text">in number of LinkedIn Posts</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">X (Twitter) Posts</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field type="number" solo dense v-model.number="no_of_x_posts" min="0" hide-details></v-text-field>
                <span class="hint--text">in number of X (Twitter) Posts</span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list class="pt-0">
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  Youtube
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                type="number"
                solo
                dense
                v-model.number="youtube"
                min="0"
                hide-details></v-text-field>
                <span class="hint--text">in number of Youtube videos</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  Loading/Whitelisting
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                type="number"
                min="0"
                hide-details
                solo
                dense
                v-model="loading_whitelisting"></v-text-field>
                <span class="hint--text">in months</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  Exclusivity
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                type="number"
                min="0"
                solo
                dense
                v-model="exclusivity"
                hide-details></v-text-field>
                <span class="hint--text">in months</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  Physical Attendance
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                type="number"
                solo
                dense
                v-model.number="physical_attendance"
                min="0"
                hide-details>
                </v-text-field>
                <span class="hint--text">in hours</span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="mb--10">
              <v-list-item-content class="pt-2">
                <v-list-item-title class="subtitle-1">
                  Online Attendance
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                type="number"
                solo
                dense
                v-model.number="online_attendance"
                min="0"
                hide-details>
                </v-text-field>
                <span class="hint--text">in hours</span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list class="pt-0">
            <v-list-item v-for="(custom, index) in customDeliverables" :key="index" class="mb--10">
              <v-list-item-content class="pt-0" style="margin-top:-10px">
                <v-list-item-title class="subtitle-2">
                  Custom
                </v-list-item-title>
                <v-text-field
                  dense
                  v-model="custom.label"
                  hide-details
                ></v-text-field>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                style="max-width:200px"
                type="number"
                solo
                append-outer-icon="mdi-delete-forever"
                v-model.number="custom.value"
                @click:append-outer="deleteCustom(index)">
              </v-text-field>
              </v-list-item-action>
            </v-list-item>
            <!-- // Disable the add custom deliverables
              <v-list-item style="margin-top: -20px">
                <v-btn
                rounded
                color="secondary"
                @click="appendNewCustom()">
                <v-icon small>mdi-plus</v-icon> Add Custom
                </v-btn>
              </v-list-item> 
            -->
          </v-list>
        <!-- // Disable the Affort Multipliers, to be resume after rework on price predictions
          <v-list dense class="body-1">
            <v-list-item>
              <v-list-item-content>Affinity Base Predicted Price1:</v-list-item-content>
              <v-list-item-action class="align-end">$ {{ influencer.predictedAmount | currency }}</v-list-item-action>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>Affinity Base Predicted Price2:</v-list-item-content>
              <v-list-item-action class="align-end">$ {{ influencer.predictedAmountHigh }}</v-list-item-action>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>Actual Price (Multiplied):</v-list-item-content>
              <v-list-item-action class="align-end">$ {{ multipliedAmount(influencer.predictedAmount, influencer.predictedAmountHigh) }}</v-list-item-action>
            </v-list-item>

          </v-list>
          <v-divider class="ma-0"></v-divider>
          <v-row align="center" justify="center">
            <v-col cols="12" md="6">
              <v-radio-group row mandatory hide-details v-model="selectedPriceMethod" class="ma-0">
                <v-radio class="ma-2" label="Price 1" value="price1"></v-radio>
                <v-radio class="ma-2" label="Price 2" value="price2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="12" md="8">
              <v-alert
                v-if="showEmptyAlert"
                color="red"
                outlined
                text
                type="error"
              >
                Effort multiplier is empty for this Influencer.
              </v-alert>
              <v-expansion-panels v-else>
                <v-expansion-panel>
                  <v-expansion-panel-header>Effort Multiplier</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <tbody>
                          <tr>
                            <td>Required Action</td>
                            <td>{{ priceEffortMultiplier.requiredActionMultiplier }}</td>
                          </tr>
                          <tr>
                            <td>Time Required</td>
                            <td>{{ priceEffortMultiplier.timeRequiredMultiplier }}</td>
                          </tr>
                          <tr>
                            <td>Experience/Product Value</td>
                            <td>{{ priceEffortMultiplier.productValueMultiplier }}</td>
                          </tr>
                          <tr>
                            <td>Audience Credibility</td>
                            <td>{{ priceEffortMultiplier.audienceCredibilityMultiplier }}</td>
                          </tr>
                          <tr>
                            <td>Deliverables</td>
                            <td>{{ priceEffortMultiplier.deliverablesMultiplier }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row> 
        -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close()">Close</v-btn>
          <v-btn class="secondary" @click="save()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import pairingAPIs from '../../Pairing/pairingAPIs';
export default {
  props: {
    value: Boolean,
    pairedInfluencer: Object,
    campaignData: Object,
    multiple: Boolean,
    multipleInfs: Array
  },
  data: () => ({
    influencer: null,
    campaign: null,
    selectedPriceMethod: null,
    priceEffortMultiplier: {},
    showEmptyAlert: false,
    // pairedAmount: 0,
    no_of_tiktok_posts: 0,
    no_of_xhs_posts: 0,
    no_of_fb_posts: 0,
    no_of_posts: 0,
    no_of_carousels: 0,
    no_of_video: 0,
    no_of_stories: 0,
    no_of_reels: 0,
    no_of_li_posts: 0,
    no_of_x_posts: 0,
    loading_whitelisting: 0,
    youtube: 0,
    exclusivity: 0,
    physical_attendance: 0,
    online_attendance: 0,
    customDeliverables: []
  }),
  methods: {
    close() {
      this.$emit('input')
    },
    save() {
      if (this.multiple) {
        this.saveMultiple()
        return
      }
      let saveCustomDeliverables = this.customDeliverables.filter(custom => custom.label)
      let data = {
        pairingID: this.influencer.pairingID,
        // amount: this.pairedAmount,
        no_of_tiktok_posts: this.no_of_tiktok_posts,
        no_of_fb_posts: this.no_of_fb_posts,
        no_of_xhs_posts: this.no_of_xhs_posts,
        no_of_posts: this.no_of_posts,
        no_of_carousels: this.no_of_carousels,
        no_of_stories: this.no_of_stories,
        no_of_reels: this.no_of_reels + this.no_of_video,
        no_of_li_posts: this.no_of_li_posts,
        no_of_x_posts: this.no_of_x_posts,
        loading_whitelisting: parseInt(this.loading_whitelisting),
        youtube: this.youtube,
        exclusivity: parseInt(this.exclusivity),
        physical_attendance: this.physical_attendance,
        online_attendance: this.online_attendance,
        customDeliverables: saveCustomDeliverables,
        remarks: this.pairedInfluencer.remarks || ''
      };
      pairingAPIs
        .updatePairingStatus(data)
        .then(() => {
          this.$swal({
            position: 'top-center',
            title: 'Saved Changes',
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          this.$emit('savedFromPriceMultplier');
        })
        .catch(error => {
          this.$swal({
            position: 'top-center',
            title: 'Error while updating pairing',
            type: 'error',
            timer: 1500
          });
          console.log(error);
        });
    },
    async saveMultiple() {
      let data = {}
      for (let inf of this.multipleInfs) {
        let saveCustomDeliverables = this.customDeliverables.filter(custom => custom.label)
        data = {
          pairingID: inf.pairingID,
          // amount: this.pairedAmount,
          no_of_tiktok_posts: this.no_of_tiktok_posts,
          no_of_fb_posts: this.no_of_fb_posts,
          no_of_xhs_posts: this.no_of_xhs_posts,
          no_of_posts: this.no_of_posts,
          no_of_carousels: this.no_of_carousels,
          no_of_stories: this.no_of_stories,
          no_of_reels: this.no_of_reels + this.no_of_video,
          no_of_li_posts: this.no_of_li_posts,
          no_of_x_posts: this.no_of_x_posts,
          loading_whitelisting: parseInt(this.loading_whitelisting),
          youtube: this.youtube,
          exclusivity: parseInt(this.exclusivity),
          physical_attendance: this.physical_attendance,
          online_attendance: this.online_attendance,
          customDeliverables: saveCustomDeliverables,
          remarks: inf.remarks || ''
        };
        await pairingAPIs.updatePairingStatus(data)
      }
      this.$swal({
        position: 'top-center',
        title: 'Saved Changes',
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      });
      this.$emit('clearSelected')
      this.$emit('savedFromPriceMultplier');
    },
    multipliedAmount(price1, price2) {
      if (this.selectedPriceMethod === 'price1') {
        return this.calculateActulPrice(Number(price1))
      } else if (this.selectedPriceMethod === 'price2') {
        return this.calculateActulPrice(Number(price2))
      } else {
        return 0
      }
    },
    calculateActulPrice(predictedPrice) {
      let basePrice = predictedPrice
      let requiredActionMultiplier = this.priceEffortMultiplier.requiredActionMultiplier
      let timeRequiredMultiplier = this.priceEffortMultiplier.timeRequiredMultiplier
      let productValueMultiplier = this.priceEffortMultiplier.productValueMultiplier
      let audienceCredibilityMultiplier = this.priceEffortMultiplier.audienceCredibilityMultiplier
      let deliverablesMultiplier = this.getDeliverablesMultiplier(Number(this.no_of_tiktok_posts), Number(this.no_of_posts), Number(this.no_of_carousels), Number(this.no_of_video), Number(this.no_of_stories), Number(this.no_of_reels))
      this.priceEffortMultiplier.deliverablesMultiplier = deliverablesMultiplier // to show updated multiplier value
      var actualPrice = Math.round((basePrice * requiredActionMultiplier * timeRequiredMultiplier * productValueMultiplier * audienceCredibilityMultiplier * deliverablesMultiplier) * 100) / 100
      return actualPrice
    },
    getDeliverablesMultiplier(tikTokPostCount, postCount, carouselsCount, videoCount, storyCount, reelCount) {
      const arbValueVideo = 1.2
      const arbValueStory = 0.5
      const arbValueReel = 2
      let tiktokPostResult = tikTokPostCount > 0 ? Math.round((1 + Math.log10(tikTokPostCount)) * 100) / 100 : 1
      let postResult = postCount > 0 ? Math.round((1 + Math.log10(postCount)) * 100) / 100 : 1
      let carouselsResult = carouselsCount > 0 ? Math.round((1 + Math.log10(carouselsCount)) * 100) / 100 : 1
      let videoResult = videoCount > 0 ? Math.round(((1 + Math.log10(videoCount)) * arbValueVideo) * 100) / 100 : 1
      let storyResult = storyCount > 0 ? Math.round(((1 + (Math.log10(storyCount) * arbValueStory))) * 100) / 100 : 1
      let reelResult = reelCount > 0 ? Math.round(((1 + (Math.log10(reelCount) * arbValueReel))) * 100) / 100 : 1
      return Math.round((tiktokPostResult * postResult * carouselsResult * videoResult * storyResult * reelResult) * 100) / 100
    },
    appendNewCustom() {
      this.customDeliverables.push({
        label: '',
        value: 0
      })
    },
    deleteCustom(index) {
      this.customDeliverables.splice(index, 1)
    },
    resetData() {
      this.no_of_tiktok_posts = 0
      this.no_of_fb_posts = 0
      this.no_of_xhs_posts = 0
      this.no_of_posts = 0
      this.no_of_carousels = 0
      this.no_of_video = 0
      this.no_of_stories = 0
      this.no_of_reels = 0
      this.no_of_li_posts = 0
      this.no_of_x_posts = 0
      this.loading_whitelisting = 0
      this.youtube = 0
      this.exclusivity = 0
      this.physical_attendance = 0
      this.online_attendance = 0
      this.customDeliverables = 0
    }
  },
  watch: {
    pairedInfluencer(newData) {
      this.resetData()
      if (newData) {
        this.influencer = Object.assign({}, newData);
        // this.pairedAmount = newData.payoutAmount
        if (!this.multiple) {
          this.no_of_tiktok_posts = newData.no_of_tiktok_posts
          this.no_of_fb_posts = newData.no_of_fb_posts || 0
          this.no_of_xhs_posts = newData.no_of_xhs_posts
          this.no_of_posts = newData.no_of_posts
          this.no_of_carousels = newData.no_of_carousels
          this.no_of_video = newData.no_of_video
          this.no_of_stories = newData.no_of_stories
          this.no_of_reels = newData.no_of_reels
          this.no_of_li_posts = newData.no_of_li_posts || 0
          this.no_of_x_posts = newData.no_of_x_posts || 0
          this.loading_whitelisting = newData.loading_whitelisting || 0
          this.youtube = newData.youtube || 0
          this.exclusivity = newData.exclusivity || 0
          this.physical_attendance = newData.physical_attendance || 0
          this.online_attendance = newData.online_attendance || 0
          this.customDeliverables = newData.customDeliverables
          this.priceEffortMultiplier = Object.assign({}, newData.priceEffortMultiplier)
          Object.keys(this.priceEffortMultiplier).length === 0 && this.priceEffortMultiplier.constructor === Object ? this.showEmptyAlert = true : this.showEmptyAlert = false
        }
        // if (newData.customDeliverables.length === 0) this.appendNewCustom()
      }
    },
    campaignData(newData) {
      if (newData) {
        this.campaign = Object.assign({}, newData);
      }
    }
  }
};
</script>
<style scoped>
  .hint--text {
    flex: 1 1 auto;
    font-size: 12px;
    min-height: 14px;
    min-width: 1px;
    position: relative;
    color: #00000099;
  }
  .mb--10 {
    margin-bottom: -10px;
  }
</style>



// WEBPACK FOOTER //
// PriceMultiplierModal.vue?5d643be8